// js
import { connect } from 'react-redux';
import dsaView from './dsaView';
import Correlations from '../components/correlations/Correlations';
import { getCorrelationsWithAnswersByCategoryWithProgress, getCompletedCorrelationCategoriesCount, getEssentialCorrelations, getAllCorrelations, getAnsweredCorrelations } from '../selectors/dsa/correlationSelectors';
import { answerCorrelation, batchAnswerCorrelations } from '../actions/correlationActions';
import { getAbilities } from '../selectors/dsa/abilitiesSelectors';


const mapStateToProps = state => {

  return {
    categories: getCorrelationsWithAnswersByCategoryWithProgress(state),
    completedCategoriesCount: getCompletedCorrelationCategoriesCount(state),
    essentialCorrelations: getEssentialCorrelations(state),
    allCorrelations: getAllCorrelations(state),
    answeredCorrelations: getAnsweredCorrelations(state),
    abilities: getAbilities(state)
  };
};

const mapDispatchToProps = dispatch => {

  return {
    onAnswerCorrelation: (correlation) => (
      (answer) => dispatch(answerCorrelation(correlation, answer))
    ),
    onBatchAnswerCorrelations: (yes, no, clear) => (
      dispatch(batchAnswerCorrelations(yes, no, clear))
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(dsaView(Correlations));



// WEBPACK FOOTER //
// ./src/containers/Correlations.js